import { Outlet, useLocation } from 'react-router';
import { Flex, Stack } from '@chakra-ui/react';

import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import ListMenu from './components/ListMenu';
import { SIDEBAR_WIDTH } from './utils/sizes';

const Dashboard = () => {
  const location = useLocation();

  const isRootPage = location.pathname === '/painel';

  return (
    <>
      <Navbar hideFrom="md" />
      <Flex flex="1">
        <Sidebar hideBelow="md" />
        <Stack
          px={{ base: 4, md: 6 }}
          py={{ base: 4, md: 6 }}
          flex="1"
          alignItems="stretch"
          marginLeft={{ base: 0, md: SIDEBAR_WIDTH }}
        >
          {isRootPage ? (
            <ListMenu />
          ) : (
            <Outlet />
          )}
        </Stack>
      </Flex>
    </>
  );
};

export default Dashboard;
